const TOOLTIP = {
  exportAsCSV: "export data as a CSV file",
}

export default TOOLTIP
